export const getDiscountedPriceVariant = (variant?: string) => {
  switch (variant) {
    case "verticalProductCard":
    case "topBlock":
    case "horizontalProductCard":
    case "basketCard":
      return "body-md-bold";

    case "pricingOptionCard":
      return "body-sm-bold";
    default:
      return "body-md-bold";
  }
};

export const originalPriceVariant = (variant?: string) => {
  switch (variant) {
    case "verticalProductCard":
    case "horizontalProductCard":
      return "body-md";

    case "basketCard":
    case "topBlock":
      return "body-sm";

    case "pricingOptionCard":
      return "smallprint-md";
    default:
      return "body-md";
  }
};
